import { RouteCoverageFilterArg } from '../types/route-coverage-filter-args'
import { Route } from '../types/route'
import { ContrastQueryParameters } from './contrast-query-params'

export function normalizeRoute({
  route_hash: hash,
  vulnerabilities: vulnerabilityCount,
  critical_vulnerabilities: criticalVulnerabilityCount,
  servers,
  servers_total: serversTotal,
  signature,
  environments,
  discovered,
  exercised,
  status,
  app
}): Route {
  return {
    id: hash,
    signature,
    discovered,
    exercised,
    hash,
    vulnerabilityCount,
    criticalVulnerabilityCount,
    environments,
    servers: servers.map(
      ({
        server_id: id,
        agent_version: agentVersion,
        serverpath: path,
        ...server
      }) => {
        return {
          id,
          agentVersion,
          path,
          ...server
        }
      }
    ),
    serversTotal,
    status,
    app: {
      id: app.app_id,
      name: app.name
    }
  }
}

export function mapRouteCoverageFilters(filters: RouteCoverageFilterArg) {
  const {
    quickFilter,
    filterText,
    dateFilter,
    discoveredDateFilter,
    applications,
    agentSessionId
  } = filters

  return {
    filterText,
    quickFilter,
    startDate: dateFilter && dateFilter.start.getTime(),
    endDate: dateFilter && dateFilter.end.getTime(),
    discoveredStartDate:
      discoveredDateFilter && discoveredDateFilter.start.getTime(),
    discoveredEndDate:
      discoveredDateFilter && discoveredDateFilter.end.getTime(),
    applicationIds: applications,
    agentSessionId
  }
}

export function appendRouteCoverageFiltersToParams(
  params: ContrastQueryParameters,
  filters: RouteCoverageFilterArg | undefined
) {
  if (filters) {
    const mappedFilters = mapRouteCoverageFilters(filters)

    const {
      filterText,
      quickFilter,
      startDate,
      endDate,
      discoveredStartDate,
      discoveredEndDate,
      applicationIds,
      agentSessionId
    } = mappedFilters

    if (filterText) {
      params.append('filterText', filterText)
    }

    params.append('quickFilter', quickFilter ? quickFilter : 'ALL')

    if (startDate !== undefined) {
      params.append('startDate', startDate)
    }
    if (endDate !== undefined) {
      params.append('endDate', endDate)
    }

    if (discoveredStartDate !== undefined) {
      params.append('discoveredStartDate', discoveredStartDate)
    }
    if (discoveredEndDate !== undefined) {
      params.append('discoveredEndDate', discoveredEndDate)
    }

    if (applicationIds) {
      applicationIds.forEach((applicationId) =>
        params.append('applicationIds', applicationId)
      )
    }

    if (agentSessionId) {
      agentSessionId.forEach((id) => params.append('agentSessionId', id))
    }
  }
}

export function appendRouteFiltersToBody(
  filters: RouteCoverageFilterArg | undefined
) {
  if (filters) {
    const {
      filterText,
      quickFilter,
      startDate,
      endDate,
      discoveredStartDate,
      discoveredEndDate,
      applicationIds,
      agentSessionId
    } = mapRouteCoverageFilters(filters)

    let body: any = {
      quickFilter: quickFilter ? quickFilter : 'ALL',
      filterText,
      startDate,
      endDate,
      discoveredStartDate,
      discoveredEndDate,
      applicationIds,
      agentSessionId:
        agentSessionId && agentSessionId[0] ? agentSessionId[0] : undefined
    }

    if (filterText) {
      body = {
        ...body,
        filterText
      }
    }

    return body
  }

  return {}
}
